import { Wordmark } from "../brand/Wordmark";
import { ROUTES } from "../../lib/constants";

export function Footer() {
  return (
    <footer className="bg-white mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <Wordmark size="sm" />
            <p className="text-xs text-terroir mt-2">
              Wine intelligence, served via API.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 sm:gap-10">
            <div>
              <h4 className="text-xs font-medium text-noir mb-3 uppercase tracking-wider">
                Product
              </h4>
              <ul className="space-y-2">
                <li>
                  <a href={ROUTES.DATA_COVERAGE} className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir no-underline">
                    Data Coverage &amp; FAQ
                  </a>
                </li>
                <li>
                  <a
                    href={ROUTES.DOCS}
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    API Documentation
                  </a>
                </li>
                <li>
                  <a
                    href={ROUTES.MCP}
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    MCP Server
                  </a>
                </li>
                <li>
                  <a
                    href="/#pricing"
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    Pricing
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-medium text-noir mb-3 uppercase tracking-wider">
                Account
              </h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href={ROUTES.LOGIN}
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    Login
                  </a>
                </li>
                <li>
                  <a
                    href={ROUTES.DASHBOARD}
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    Dashboard
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-medium text-noir mb-3 uppercase tracking-wider">
                Legal
              </h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href={ROUTES.TERMS}
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    href={ROUTES.PRIVACY}
                    className="inline-flex min-h-11 items-center text-sm text-terroir hover:text-noir transition-colors no-underline"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6">
          <p className="text-xs text-terroir">
            &copy; {new Date().getFullYear()} Pinnacle Ridge Cloud Solutions.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
